// extracted by mini-css-extract-plugin
export default {"cardContainer":"judge_cardContainer__+919B","showCard":"judge_showCard__Y2979","editStyle":"judge_editStyle__0JiKS","font20":"judge_font20__OF8wJ"};